<!--
 * @Author: weiShu
 * @Date: 2026-01-04 20:29:50
 * @LastEditors: weiShu
 * @LastEditTime: 2026-01-06 08:35:40
 * @FilePath: \health-commission-new\src\views\my\exam-result-detail.vue
 * @Description: 
-->
<template>
    <div class="exam-result-detail">
        
        <!-- 加载中 -->
        <div v-if="loading" class="loading-container">
            <van-loading type="spinner" color="#00BCD4">加载中...</van-loading>
        </div>
        
        <!-- 内容区域 -->
        <div v-else-if="examData" class="content">
            <!-- 考试结果头部卡片 -->
            <div class="result-header-card">
                <div class="exam-title">{{ examData.testPaperTitle || '考试' }}</div>
                <div class="score-badge-wrapper">
                    <div class="score-badge">
                        <div class="score-value-large">{{ examData.totalScore || 0 }}</div>
                        <div class="score-label">得分</div>
                    </div>
                </div>
                <div class="exam-info-footer">
                    <div class="info-item-footer">
                        <span class="info-label-footer">考试时间</span>
                        <span class="info-value-footer">{{ formatExamTime(examData.startTime) }}</span>
                    </div>
                    <div class="info-item-footer">
                        <span class="info-label-footer">考试用时</span>
                        <span class="info-value-footer">{{ calculateDuration(examData.startTime, examData.endTime) }}</span>
                    </div>
                </div>
            </div>
            
            <!-- 题目列表容器 -->
            <div class="questions-container">
                <!-- 待批阅题目列表 -->
                <div v-if="examData.unreviewedList && examData.unreviewedList.length > 0" class="question-section">
                    <div class="section-title pending-title">
                        <van-icon name="clock-o" color="#FF9800" size="16" />
                        <span>待批阅题目 ({{ examData.unreviewedList.length }})</span>
                    </div>
                    <div 
                        class="question-item pending-item" 
                        v-for="(item, index) in examData.unreviewedList" 
                        :key="index"
                    >
                        <div class="question-header">
                            <span class="question-number">第{{ index + 1 }}题</span>
                            <span class="question-type">{{ (item.topic && item.topic.type) || (item.topic && item.topic.category) || '--' }}</span>
                            <span class="question-score pending-score">待批阅</span>
                        </div>
                        <div class="question-content">
                            <div class="question-title">{{ (item.topic && item.topic.title) || '--' }}</div>
                            
                            <!-- 选择题显示选项 -->
                            <div v-if="item.topic && ['单选题', '多选题', '判断题'].includes(item.topic.type)" class="options-list">
                                <div 
                                    class="option-item"
                                    v-for="(option, optIndex) in (item.topic && item.topic.options) || []" 
                                    :key="optIndex"
                                >
                                    <span class="option-label">{{ option.label }}、</span>
                                    <span class="option-text">{{ option.text }}</span>
                                </div>
                            </div>
                            
                            <!-- 答案显示 -->
                            <div class="answer-section">
                                <div class="answer-label">您的答案：</div>
                                <div class="answer-value user-answer pending-answer">
                                    <span v-if="isUserAnswerEmpty(item.answer)" class="unanswered-text">未作答</span>
                                    <template v-else>
                                    <!-- 计算题显示图片 -->
                                    <div v-if="(item.topic && item.topic.type === '计算题') || (item.topic && item.topic.category === '计算题')" class="answer-image">
                                        <img :src="item.answer" alt="答案图片" />
                                    </div>
                                    <!-- 选择题显示带标签的答案 -->
                                    <span v-else-if="item.topic && ['单选题', '多选题', '判断题'].includes(item.topic.type)">
                                        {{ formatAnswerWithLabel(item.answer, item.topic.options) }}
                                    </span>
                                    <!-- 其他类型显示文本 -->
                                    <span v-else-if="Array.isArray(item.answer)">
                                        {{ item.answer.join(', ') }}
                                    </span>
                                    <span v-else>{{ item.answer }}</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- 答对题列表 -->
                <div v-if="examData.rightList && examData.rightList.length > 0" class="question-section">
                    <div class="section-title">
                        <van-icon name="success" color="#4CAF50" size="16" />
                        <span>答对题目 ({{ examData.rightList.length }})</span>
                    </div>
                    <div 
                        class="question-item" 
                        v-for="(item, index) in examData.rightList" 
                        :key="index"
                    >
                        <div class="question-header">
                            <span class="question-number">第{{ index + 1 }}题</span>
                            <span class="question-type">{{ (item.topic && item.topic.type) || (item.topic && item.topic.category) || '--' }}</span>
                            <span class="question-score">得分: {{ item.score || 0 }}分</span>
                        </div>
                        <div class="question-content">
                            <div class="question-title">{{ (item.topic && item.topic.title) || '--' }}</div>
                            
                            <!-- 选择题显示选项 -->
                            <div v-if="item.topic && ['单选题', '多选题', '判断题'].includes(item.topic.type)" class="options-list">
                                <div 
                                    class="option-item"
                                    v-for="(option, optIndex) in (item.topic && item.topic.options) || []" 
                                    :key="optIndex"
                                >
                                    <span class="option-label">{{ option.label }}、</span>
                                    <span class="option-text">{{ option.text }}</span>
                                </div>
                            </div>
                            
                            <!-- 答案显示 -->
                            <div class="answer-section">
                                <div class="answer-label">正确答案：</div>
                                <div class="answer-value correct-answer">
                                    <span v-if="item.topic && ['单选题', '多选题', '判断题'].includes(item.topic.type)">
                                        {{ formatAnswerWithLabel(item.topic.answer, item.topic.options) }}
                                    </span>
                                    <span v-else-if="item.topic && Array.isArray(item.topic.answer)">
                                        {{ item.topic.answer.join(', ') }}
                                    </span>
                                    <span v-else-if="item.topic && item.topic.answer">{{ item.topic.answer }}</span>
                                    <span v-else>--</span>
                                </div>
                            </div>
                            
                            <div class="answer-section">
                                <div class="answer-label">您的答案：</div>
                                <div class="answer-value user-answer">
                                    <span v-if="isUserAnswerEmpty(item.answer)" class="unanswered-text">未作答</span>
                                    <template v-else>
                                    <!-- 计算题显示图片 -->
                                    <div v-if="(item.topic && item.topic.type === '计算题') || (item.topic && item.topic.category === '计算题')" class="answer-image">
                                        <img :src="item.answer" alt="答案图片" />
                                    </div>
                                    <!-- 选择题显示带标签的答案 -->
                                    <span v-else-if="item.topic && ['单选题', '多选题', '判断题'].includes(item.topic.type)">
                                        {{ formatAnswerWithLabel(item.answer, item.topic.options) }}
                                    </span>
                                    <!-- 其他类型显示文本 -->
                                    <span v-else-if="Array.isArray(item.answer)">
                                        {{ item.answer.join(', ') }}
                                    </span>
                                    <span v-else>{{ item.answer }}</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- 答错题列表 -->
                <div v-if="examData.wrongList && examData.wrongList.length > 0" class="question-section">
                    <div class="section-title error-title">
                        <van-icon name="cross" color="#F44336" size="16" />
                        <span>答错题目 ({{ examData.wrongList.length }})</span>
                    </div>
                    <div 
                        class="question-item error-item" 
                        v-for="(item, index) in examData.wrongList" 
                        :key="index"
                    >
                        <div class="question-header">
                            <span class="question-number">第{{ index + 1 }}题</span>
                            <span class="question-type">{{ (item.topic && item.topic.type) || (item.topic && item.topic.category) || '--' }}</span>
                            <span class="question-score">得分: {{ item.score || 0 }}分</span>
                        </div>
                        <div class="question-content">
                            <div class="question-title">{{ (item.topic && item.topic.title) || '--' }}</div>
                            
                            <!-- 选择题显示选项 -->
                            <div v-if="item.topic && ['单选题', '多选题', '判断题'].includes(item.topic.type)" class="options-list">
                                <div 
                                    class="option-item"
                                    v-for="(option, optIndex) in (item.topic && item.topic.options) || []" 
                                    :key="optIndex"
                                >
                                    <span class="option-label">{{ option.label }}、</span>
                                    <span class="option-text">{{ option.text }}</span>
                                </div>
                            </div>
                            
                            <!-- 答案显示 -->
                            <div class="answer-section">
                                <div class="answer-label">正确答案：</div>
                                <div class="answer-value correct-answer">
                                    <span v-if="item.topic && ['单选题', '多选题', '判断题'].includes(item.topic.type)">
                                        {{ formatAnswerWithLabel(item.topic.answer, item.topic.options) }}
                                    </span>
                                    <span v-else-if="item.topic && Array.isArray(item.topic.answer)">
                                        {{ item.topic.answer.join(', ') }}
                                    </span>
                                    <span v-else-if="item.topic && item.topic.answer">{{ item.topic.answer }}</span>
                                    <span v-else>--</span>
                                </div>
                            </div>
                            
                            <div class="answer-section">
                                <div class="answer-label">您的答案：</div>
                                <div class="answer-value user-answer error-answer">
                                    <span v-if="isUserAnswerEmpty(item.answer)" class="unanswered-text">未作答</span>
                                    <template v-else>
                                    <!-- 计算题显示图片 -->
                                    <div v-if="(item.topic && item.topic.type === '计算题') || (item.topic && item.topic.category === '计算题')" class="answer-image">
                                        <img :src="item.answer" alt="答案图片" />
                                    </div>
                                    <!-- 选择题显示带标签的答案 -->
                                    <span v-else-if="item.topic && ['单选题', '多选题', '判断题'].includes(item.topic.type)">
                                        {{ formatAnswerWithLabel(item.answer, item.topic.options) }}
                                    </span>
                                    <!-- 其他类型显示文本 -->
                                    <span v-else-if="Array.isArray(item.answer)">
                                        {{ item.answer.join(', ') }}
                                    </span>
                                    <span v-else>{{ item.answer }}</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- 空状态 -->
                <div v-if="(!examData.unreviewedList || examData.unreviewedList.length === 0) && (!examData.rightList || examData.rightList.length === 0) && (!examData.wrongList || examData.wrongList.length === 0)" class="empty-state">
                    <van-empty description="暂无题目信息" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getTestPaperInfo } from '@/api/index.js'

export default {
    name: 'ExamResultDetail',
    data() {
        return {
            loading: true,
            examData: null
        }
    },
    created() {
        this.loadExamData()
    },
    methods: {
        // 格式化考试时间
        formatExamTime(timeStr) {
            if (!timeStr) return '--'
            // 将时间格式转换为 YYYY/MM/DD HH:mm
            const date = new Date(timeStr)
            if (isNaN(date.getTime())) return timeStr
            
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            
            return `${year}/${month}/${day} ${hours}:${minutes}`
        },
        // 计算考试用时
        calculateDuration(startTime, endTime) {
            if (!startTime || !endTime) {
                return '--'
            }
            
            const start = new Date(startTime)
            const end = new Date(endTime)
            
            if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                return '--'
            }
            
            const duration = end - start
            const hours = Math.floor(duration / (1000 * 60 * 60))
            const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60))
            const seconds = Math.floor((duration % (1000 * 60)) / 1000)
            
            if (hours > 0) {
                return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
            } else {
                return `${minutes}:${String(seconds).padStart(2, '0')}`
            }
        },
        // 处理选项数据
        processOptions(options) {
            if (!options || !Array.isArray(options)) {
                return []
            }
            
            return options.map((opt, index) => {
                // 生成字母标签 A-Z
                const label = String.fromCharCode(65 + index) // 65 是 'A' 的 ASCII 码
                return {
                    label: label,
                    text: opt.text || opt.content || opt,
                    value: opt.value || opt.id || index
                }
            })
        },
        // 用户是否未作答（计算题图片、选择/文本/数组）
        isUserAnswerEmpty(answer) {
            if (answer === null || answer === undefined) return true
            if (Array.isArray(answer)) {
                if (answer.length === 0) return true
                const nonEmpty = answer.some(
                    a => a != null && String(a).trim() !== ''
                )
                return !nonEmpty
            }
            if (typeof answer === 'string') {
                return answer.trim() === ''
            }
            return false
        },
        // 格式化答案，添加选项标签
        formatAnswerWithLabel(answer, options) {
            if (!answer || !options || options.length === 0) {
                return answer || '--'
            }
            
            // 如果是数组（多选题）
            if (Array.isArray(answer)) {
                return answer.map(ans => {
                    const option = options.find(opt => opt.text === ans)
                    return option ? `${option.label}、${option.text}` : ans
                }).join(', ')
            }
            
            // 单个答案
            const option = options.find(opt => opt.text === answer)
            return option ? `${option.label}、${option.text}` : answer
        },
        async loadExamData() {
            const answerId = this.$route.query.answerId
            if (!answerId) {
                this.$toast('缺少答卷ID')
                this.$router.go(-1)
                return
            }
            
            try {
                this.loading = true
                this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true
                })
                
                const res = await getTestPaperInfo(answerId)
                this.$toast.clear()
                
                if (res.code === 200 && res.data) {
                    this.examData = res.data
                    
                    // 处理未批阅题目列表的选项
                    if (this.examData.unreviewedList && Array.isArray(this.examData.unreviewedList)) {
                        this.examData.unreviewedList.forEach(item => {
                            if (item.topic && item.topic.options) {
                                item.topic.options = this.processOptions(item.topic.options)
                            }
                        })
                    }
                    
                    // 处理答对题列表的选项
                    if (this.examData.rightList && Array.isArray(this.examData.rightList)) {
                        this.examData.rightList.forEach(item => {
                            if (item.topic && item.topic.options) {
                                item.topic.options = this.processOptions(item.topic.options)
                            }
                        })
                    }
                    
                    // 处理答错题列表的选项
                    if (this.examData.wrongList && Array.isArray(this.examData.wrongList)) {
                        this.examData.wrongList.forEach(item => {
                            if (item.topic && item.topic.options) {
                                item.topic.options = this.processOptions(item.topic.options)
                            }
                        })
                    }
                } else {
                    this.$toast('获取考试详情失败')
                }
            } catch (error) {
                this.$toast.clear()
                console.error('加载考试详情失败:', error)
                this.$toast('加载失败，请稍后重试')
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style scoped lang="scss">
.exam-result-detail {
    min-height: 100vh;
    background: #F5F5F5;
    padding-bottom: 20px;
}

.loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 100px 0;
}

.content {
    padding: 0;
}

.result-header-card {
    box-sizing: border-box;
    padding: 36px 15px 0;
    width: 100%;
    height: 381px;
    position: relative;
    background: url('~@/assets/image/exam-result-detail-bg.png') no-repeat center center;
    background-size: 100% 100%;
    overflow: hidden;
}

.exam-title {
    position: relative;
    font-size: 22px;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 1.5;
    word-break: break-all;
    z-index: 5;
}

.score-badge-wrapper {
    margin-top: -30px;
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
}

.score-badge {
    position: relative;
    width: 206px;
    height: 206px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url('~@/assets/image/exam-result-detail-score-bg.png') no-repeat center center;
    background-size: 100% 100%;
}

.score-value-large {
    font-size: 48px;
    font-weight: bold;
    color: #FFD700;
    line-height: 1;
    margin-bottom: 8px;
}

.score-label {
    font-size: 14px;
    color: #FFFFFF;
    font-weight: 400;
}

.exam-info-footer {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: -40px;
    z-index: 11;
}

.info-item-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
}
.info-item-footer:first-child{
    border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.info-label-footer {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 4px;
}

.info-value-footer {
    font-size: 14px;
    color: #FFFFFF;
    font-weight: 500;
}

.questions-container {
    position: relative;
    margin: -90px 15px 0;
    z-index: 12;
    border-radius: 12px 12px 0 0;
    background: #F5F5F5;
}

.question-section {
    margin-bottom: 20px;
    
    &:last-child {
        margin-bottom: 0;
        
        .question-item:last-child {
            margin-bottom: 0 !important;
        }
    }
}

.section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 12px;
    padding: 12px 16px;
    background: #fff;
    border-radius: 12px;
    
    &.error-title {
        color: #F44336;
    }
    
    &.pending-title {
        color: #FF9800;
    }
}

.question-item {
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    
    &.error-item {
        border-left: 3px solid #F44336;
    }
    
    &.pending-item {
        border-left: 3px solid #FF9800;
    }
}

.question-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f5f5f5;
}

.question-number {
    font-size: 14px;
    color: #666;
    font-weight: 500;
}

.question-type {
    font-size: 12px;
    color: #999;
    background: #f5f5f5;
    padding: 2px 8px;
    border-radius: 4px;
}

.question-score {
    font-size: 14px;
    color: #4CAF50;
    font-weight: 500;
    margin-left: auto;
    
    &.pending-score {
        color: #FF9800;
    }
}

.question-content {
    margin-top: 12px;
}

.question-title {
    font-size: 15px;
    color: #333;
    line-height: 1.6;
    margin-bottom: 12px;
}

.options-list {
    margin: 12px 0;
}

.option-item {
    display: flex;
    align-items: flex-start;
    padding: 8px 0;
    font-size: 14px;
    color: #666;
    line-height: 1.6;
}

.option-label {
    font-weight: 500;
    margin-right: 4px;
}

.answer-section {
    margin-top: 12px;
    padding: 12px;
    background: #f9f9f9;
    border-radius: 8px;
}

.answer-label {
    font-size: 13px;
    color: #999;
    margin-bottom: 6px;
}

.answer-value {
    font-size: 14px;
    color: #333;
    line-height: 1.6;
    word-break: break-all;
    
    &.correct-answer {
        color: #4CAF50;
        font-weight: 500;
    }
    
    &.user-answer {
        color: #666;
        
        &.error-answer {
            color: #F44336;
        }
        
        &.pending-answer {
            color: #FF9800;
        }
    }
}

.empty-state {
    padding: 60px 20px;
    text-align: center;
}

.answer-image {
    margin-top: 8px;
    
    img {
        max-width: 100%;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
}

.unanswered-text {
    color: #f44336;
    font-weight: 500;
}
</style>

